import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import NotificationTemplateScreen from './screens/NotificationTemplateScreen';
import MainLayout from './Layout/MainLayout';
import NotificationForm from './components/NotificationTemplate/NotificationForm';
import LoginScreen from './screens/LoginScreen';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from './components/ProtectedRoutes/ProtectedRoutes';
import UserScreen from './screens/UserScreen';
import FeedbackScreen from './screens/FeedbackScreen';
import ComingSoon from './screens/ComingSoon';
import PrivacyPolicy from './screens/PrivacyPolicy';
import DietScreen from "./screens/DietScreen";
import DietPlanTemplate from './screens/DietPlanTemplate';
import OrderScreen from './screens/OrderScreen';
import EmployeeRatingScreen from './screens/EmployeeRatingScreen';
import ProductScreen from './screens/ProductListScreen';
import { CreateProductPage, UpdateProductPage } from './screens/ProductScreen';
import BannerScreen from './screens/BannerScreen';
import CouponsScreen from './screens/CouponsScreen';
import Blog from './components/Blog';
import TreatmentPlan from './components/TreatmentPlan/TreatmentPlan';
import TotalTreatments from './components/TotalTreatments/TotalTreatments';
import CampingForm from './screens/CampingForm';

function App() {
  return (
    <Router basename="/ui">
      <Routes>
        <Route path="/" element={<LoginScreen />} />
        <Route
          path="*"
          element={
            <MainLayout>
              <Routes>
                <Route
                  path="/notification-template"
                  element={
                    <ProtectedRoute>
                      <NotificationTemplateScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/create"
                  element={
                    <ProtectedRoute>
                      <NotificationForm />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/users"
                  element={
                    <ProtectedRoute>
                      <UserScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/feedbacks"
                  element={
                    <ProtectedRoute>
                      <FeedbackScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/employee-rating"
                  element={
                    <ProtectedRoute>
                      <EmployeeRatingScreen/>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/diet"
                  element={
                    <ProtectedRoute>
                      <DietScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/diet-plan-template"
                  element={
                    <ProtectedRoute>
                      <DietPlanTemplate />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/Orders"
                  element={
                    <ProtectedRoute>
                      <OrderScreen />
                    </ProtectedRoute>
                  }
                />
                <Route path="/products" element={<ProductScreen/>}/>
                <Route path="/products/create" element={<CreateProductPage/>}/>
                <Route path="/products/:id/edit" element={<UpdateProductPage/>}/>
                <Route path="/banners" element={<BannerScreen/>} />
                <Route path="/coupons" element={<CouponsScreen/>} />
                <Route path="/blog" element={<Blog/>} />
                <Route path="/treatment" element={<TreatmentPlan/>} />
                <Route path="/totaltreatments" element={<TotalTreatments/>} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/CampingForm" element={<CampingForm />} />
                <Route
                  path="*"
                  element={
                    <ProtectedRoute>
                      <ComingSoon />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </MainLayout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
